import React, { useMemo, useState } from "react";

// TODO remove placeholders for fields, and create callbacks
export const CardSort = ({
  fields = [
    { name: `id`, func: (d) => d },
    { name: `date`, func: (d) => d },
    { name: `event duration`, func: (d) => d },
    { name: `featured`, func: (d) => d },
  ],
  className = "",
}) => {
  const [sortingField] = useState(fields[0]);
  const isSelected = useMemo(
    () => (d) => d.name === sortingField.name,
    [sortingField]
  );

  return (
    <div
      className={`flex flex-row justify-around ${className} mln1 border-bottom border-top`}
    >
      {fields.map((field) => (
        <div
          key={`card-sort-field-${field.name}`}
          className={`${
            isSelected(field) && `inverted`
          } p1 pointer flex flex-row`}
        >
          <div className="">{field.name}</div>
          {isSelected(field) && <div className="h6 self-end">&nbsp;▼</div>}
        </div>
      ))}
    </div>
  );
};
